const percent5 = {
    decimal: ",",
    thousands: ".",
    prefix: "% ",
    suffix: "",
    precision: 5,
    masked: false
}
  
export default percent5
